import { GLOBAL } from 'saddlebag-browser';
import { logOperationalEvent } from 'saddlebag-logger';

import { logErrorWrapper } from '../../../../services/logWrapper';
import {
  REQUEST_INITIAL_DATA_ANALYSIS,
  RECEIVE_MONTH_DATA_ANALYSIS,
  SELECT_MONTH,
  CONFIRM_SELECTED_RESULT,
  CONFIRM_SELECTED_HOTEL,
} from '../constants/actionsConstants';
import {
  BROWSE_FUNNEL_STAGE_CITY_TO_CITY,
  FLIGHT_VERTICAL,
  HOTEL_VERTICAL,
  ME_PROPERTY_BROWSE_FUNNEL_STAGE,
} from '../constants/analyticsConstants';

import {
  getFlightResultsLoadedData,
  getMonthChangedData,
  getResultSelectedData,
} from './miniEventHelper';

import type { LoggingAction } from './payload/types';
import type { State } from '../../selectors/types';
import type { Device } from 'src/services/contextAdaptor/types';

const operationalEvents: Record<string, string[]> = {
  FlightResultsLoaded: ['isInitialLoad', 'tripType'],
  MonthChanged: ['direction', 'selectedView'],
  MonthViewLoaded: [],
  ResultSelected: ['selectedView', 'vertical'],
};

export const getMessageForAction = (
  state: State,
  action: LoggingAction,
): Record<string, any> | null => {
  switch (action.type) {
    case REQUEST_INITIAL_DATA_ANALYSIS:
      return {};
    case RECEIVE_MONTH_DATA_ANALYSIS:
      return getFlightResultsLoadedData(state);
    case SELECT_MONTH:
      return getMonthChangedData(state, action);
    case CONFIRM_SELECTED_RESULT:
      return getResultSelectedData(state, FLIGHT_VERTICAL);
    case CONFIRM_SELECTED_HOTEL:
      return getResultSelectedData(state, HOTEL_VERTICAL);
    default:
      return {};
  }
};

const eventNameMap = {
  [REQUEST_INITIAL_DATA_ANALYSIS]: 'MonthViewLoaded',
  [RECEIVE_MONTH_DATA_ANALYSIS]: 'FlightResultsLoaded',
  [SELECT_MONTH]: 'MonthChanged',
  [CONFIRM_SELECTED_RESULT]: 'ResultSelected',
  [CONFIRM_SELECTED_HOTEL]: 'ResultSelected',
};

const getEventName = (actionType: string): string | undefined =>
  eventNameMap[actionType as keyof typeof eventNameMap];

export const logOperationalEventWrapper = (
  action: LoggingAction,
  state: State,
  device?: Device,
): void => {
  const eventName = getEventName(action.type);
  const $window = GLOBAL.getWindow();
  try {
    if (
      eventName &&
      operationalEvents[eventName] &&
      $window.performance &&
      typeof $window.performance.mark === 'function'
    ) {
      const message = getMessageForAction(state, action);

      // If message is null or undefined, we should not attempt to log the event eg: Automated source
      if (!message) {
        return;
      }
      const filteredMessage: Record<string, any> = {};
      operationalEvents[eventName].forEach((field: string) => {
        filteredMessage[field] = message[field];
      });

      logOperationalEvent({
        eventName,
        [ME_PROPERTY_BROWSE_FUNNEL_STAGE]: BROWSE_FUNNEL_STAGE_CITY_TO_CITY,
        ...filteredMessage,
        isRobot: `${device?.isRobot}`,
      });
    }
  } catch (err) {
    if (err instanceof Error) {
      logErrorWrapper(err, {
        component: 'logOperationalEvent',
        message: `Failed to log mini-event for ${action.type}: ${err}`,
      });
    } else {
      const error = new Error(String(err));
      logErrorWrapper(error, {
        component: 'logOperationalEvent',
        message: `Failed to log mini-event for ${action.type}: ${error}`,
      });
    }
  }
};
